import {Assert} from "common/Assert";

export function StatusCollector() {

    /***********************************************************************
     * collects the status of all given sco
     ***********************************************************************/
    function getStatus( scoIterator, scoAmmount ){

        Assert.checkArgument( scoIterator );
        Assert.checkArgumentType( scoIterator.each, "function" );
        Assert.checkArgumentType( scoAmmount, "number" );

        let result = {
            completed: 0,
            incomplete: 0,
            passed: 0,
            failed: 0,
            scoAmount: scoAmmount
        };

        scoIterator.each( (scoId, scoData) =>{

            if( scoData.isPassed() ) {
                result.passed++;
            }
            else if (scoData.isFailed()) {
                result.failed++;
            }

            if (scoData.isCompleted()) {
                result.completed++;
            }
            else  if (scoData.isIncomplete()) {
                result.incomplete++;
            }
        });

        return result;
    }

    //revealing public api
    return {
        getStatus : getStatus
    };
}
